<template>
  <div class="flex flex-col items-center justify-center h-full gap-4">
    <i class="mingcute--settings-3-line iconify text-4xl" />
    <div class="text-xl">{{ $t("SidebarNavi.selectSetting") }}</div>
  </div>
</template>
